import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Briefcase, Save, X, ChevronDown, ArrowLeft } from 'react-feather';
import config from '../../../../config';
import CustomizerContext from '../../../../_helper/Customizer';
import '../../sadmin.css';

const NewConcessionaire = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { layoutURL } = useContext(CustomizerContext);
    const layout = layoutURL || 'default';

    useEffect(() => {
        if (localStorage.getItem('usertype') !== 'sadmin') {
            alert(t('You are not authorized to view this page'));
            window.history.back();
        }
    }, []);

    const login_id = localStorage.getItem('loginId');
    const token = localStorage.getItem('sessiontoken');
    const configheader = { headers: { Authorization: `${token}` } };

    const [concessionaire_name, setName] = useState('');
    const [concessionaire_code, setCode] = useState('');
    const [concessionaire_email, setEmail] = useState('');
    const [concessionaire_phone, setPhone] = useState('');
    const [concessionaire_address, setAddress] = useState('');
    const [concessionaire_username, setUsername] = useState('');
    const [concessionaire_password, setPassword] = useState('');
    const [concessionaire_license_start_date, setLicStart] = useState('');
    const [concessionaire_license_end_date, setLicEnd] = useState('');
    const [concessionaire_active, setActive] = useState(true);
    const [data_mode, setDataMode] = useState('dailywise');
    const [audit_required, setAuditRequired] = useState(false);
    const [audit_tolerance, setAuditTolerance] = useState('');
    const [features_ai_chatbot, setAiChatbot] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    const goList = () =>
        navigate(`${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionaire/${layout}`);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (audit_required && !audit_tolerance) {
            toast.error(t('Please enter audit tolerance'));
            return;
        }
        const data = {
            concessionaire_name,
            concessionaire_code,
            concessionaire_email,
            concessionaire_phone,
            concessionaire_address,
            concessionaire_username,
            concessionaire_password,
            concessionaire_license_start_date,
            concessionaire_license_end_date,
            concessionaire_active,
            concessionaire_created_Date: new Date().toISOString().slice(0, 10),
            concessionaire_created_by: login_id,
            login_id,
            data_mode,
            audit_required,
            features: { ai_chatbot: features_ai_chatbot },
        };
        if (audit_required) data.audit_tolerance = audit_tolerance;

        setSubmitting(true);
        try {
            await axios.post(`${config.hostname}/concessionaire`, data, configheader);
            toast.success(t('Successfully added'));
            setName('');
            setCode('');
            setEmail('');
            setPhone('');
            setAddress('');
            setUsername('');
            setPassword('');
            setLicStart('');
            setLicEnd('');
            setActive(true);
            setAuditRequired(false);
            setAuditTolerance('');
            setAiChatbot(true);
        } catch (err) {
            console.error(err);
            toast.error(t('Error'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="v3 v3-sadmin">
            <header className="v3-sadmin-hero">
                <div className="v3-sadmin-hero-text">
                    <div className="v3-label">{t('Concessionaires')}</div>
                    <h1 className="v3-display v3-sadmin-greeting" style={{ fontSize: 26 }}>
                        {t('New concessionaire')}
                    </h1>
                    <p className="v3-body v3-sadmin-sub">
                        {t('Provision a new mall onto the platform. Sets up identity, license window, and audit policy.')}
                    </p>
                </div>
                <div className="v3-sadmin-hero-actions">
                    <button type="button" className="v3-btn v3-btn-ghost" onClick={goList}>
                        <ArrowLeft size={14} />
                        {t('Back to list')}
                    </button>
                </div>
            </header>

            <section className="v3-card v3-sadmin-form-card">
                <form className="v3-sadmin-form" onSubmit={handleSubmit} autoComplete="off">
                    <div className="v3-sadmin-form-grid">
                        <div className="v3-field">
                            <label className="v3-label">{t('Name')}</label>
                            <input
                                className="v3-input"
                                type="text"
                                value={concessionaire_name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={t('e.g. Yas Mall')}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Code')}</label>
                            <input
                                className="v3-input"
                                type="text"
                                value={concessionaire_code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder={t('e.g. YAS')}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Email')}</label>
                            <input
                                className="v3-input"
                                type="email"
                                value={concessionaire_email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={t('ops@mall.com')}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Phone')}</label>
                            <input
                                className="v3-input"
                                type="text"
                                value={concessionaire_phone}
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder={t('+971…')}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Username')}</label>
                            <input
                                className="v3-input"
                                type="text"
                                value={concessionaire_username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Password')}</label>
                            <input
                                className="v3-input"
                                type="password"
                                value={concessionaire_password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('License start')}</label>
                            <input
                                className="v3-input"
                                type="date"
                                value={concessionaire_license_start_date}
                                onChange={(e) => setLicStart(e.target.value)}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('License end')}</label>
                            <input
                                className="v3-input"
                                type="date"
                                value={concessionaire_license_end_date}
                                onChange={(e) => setLicEnd(e.target.value)}
                                required
                            />
                        </div>
                        <div className="v3-field" style={{ gridColumn: '1 / -1' }}>
                            <label className="v3-label">{t('Address')}</label>
                            <input
                                className="v3-input"
                                type="text"
                                value={concessionaire_address}
                                onChange={(e) => setAddress(e.target.value)}
                                required
                            />
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Status')}</label>
                            <div className="v3-select-wrap">
                                <select
                                    className="v3-input v3-select"
                                    value={concessionaire_active ? 'true' : 'false'}
                                    onChange={(e) => setActive(e.target.value === 'true')}
                                >
                                    <option value="true">{t('Active')}</option>
                                    <option value="false">{t('Inactive')}</option>
                                </select>
                                <ChevronDown size={14} className="v3-select-caret" aria-hidden />
                            </div>
                        </div>
                        <div className="v3-field">
                            <label className="v3-label">{t('Data mode')}</label>
                            <div className="v3-select-wrap">
                                <select
                                    className="v3-input v3-select"
                                    value={data_mode}
                                    onChange={(e) => setDataMode(e.target.value)}
                                >
                                    <option value="dailywise">{t('Daily-wise')}</option>
                                    <option value="transactionwise">{t('Transaction-wise')}</option>
                                </select>
                                <ChevronDown size={14} className="v3-select-caret" aria-hidden />
                            </div>
                        </div>
                    </div>

                    <div className="v3-sadmin-form-section">
                        <div className="v3-sadmin-form-section-title">{t('Audit settings')}</div>
                        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                            <label className="v3-sadmin-checkbox-row">
                                <input
                                    type="checkbox"
                                    checked={audit_required}
                                    onChange={(e) => setAuditRequired(e.target.checked)}
                                />
                                {t('Enable audit')}
                            </label>
                            <div className="v3-field" style={{ flex: 1, minWidth: 200 }}>
                                <input
                                    className="v3-input"
                                    type="number"
                                    placeholder={t('Audit tolerance (%)')}
                                    value={audit_tolerance}
                                    disabled={!audit_required}
                                    onChange={(e) => setAuditTolerance(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="v3-sadmin-form-section">
                        <div className="v3-sadmin-form-section-title">{t('AI Assistant')}</div>
                        <label className="v3-sadmin-checkbox-row">
                            <input
                                type="checkbox"
                                checked={features_ai_chatbot}
                                onChange={(e) => setAiChatbot(e.target.checked)}
                            />
                            {t('Enable AI chatbot')}
                        </label>
                    </div>

                    <div className="v3-sadmin-form-actions">
                        <button type="button" className="v3-btn v3-btn-ghost" onClick={goList}>
                            <X size={14} />
                            {t('Cancel')}
                        </button>
                        <button type="submit" className="v3-btn v3-btn-primary" disabled={submitting}>
                            <Save size={14} />
                            {submitting ? t('Adding…') : t('Add concessionaire')}
                        </button>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default NewConcessionaire;
